<template>
  <view-edit-panel
    class="registration-data"
    :disable-save="disableSave"
    v-model="circuitBreakerInfo"
    @changing="save"
  >
    <b-container
      fluid
      slot-scope="data"
      class="registration-data__fields"
    >
      <b-row v-if="!loading">
        <circuit-breaker-form
          :edit-mode="data.editing"
          :saving="data.saving"
          :circuit-breaker-info="data.item"
          @valid-data-change="onValidDataChange"
        />
      </b-row>
      <b-row v-else class="registration-data__loader" align-h="center" align-v="center">
        <s-loader size="lg" />
      </b-row>
    </b-container>
  </view-edit-panel>
</template>

<script>
import ViewEditPanel from '@/components/ViewEditPanel';
import GeneralDataService from '@/domain/services/installation/assetInfo/generalData';
import loadingMixin from '@/services/loadingMixin';
import circuitBreakerForm from '@/domain/components/installation/assetInformation/circuitBreakers/Form';
import TreeviewHeaderSubtitleMixin from '@/components/treeview/treeviewHeaderSubtitleMixin';

export default {
  name: 'CircuitBreakerGeneralData',
  props: {
    asset: Object,
    assetType: Object,
  },
  components: {
    circuitBreakerForm,
    ViewEditPanel,
  },
  mixins: [loadingMixin, TreeviewHeaderSubtitleMixin],
  data: () => ({
    circuitBreakerInfo: {
      type: null,
      installationPlace: null,
      electricArchExtinctionMethod: null,
      nominalTension: null,
      nominalChain: null,
      nominalFrequency: null,
      typicalOpeningTime: null,
      maximumClosingTime: null,
      nominalOperationSequence: null,
      supportableShortChainDuration: null,
      maintenanceHistory: null,
      observation: null,
      mechanismOperation: null,
      interruptionCapacity: {
        nominal: null,
        continuousChainPercentage: null,
      },
      supportableNominalTension: {
        applied: null,
        atmosphericImpulse: null,
        industrialFrequency: null,
      },
    },
    validData: false,
  }),
  computed: {
    disableSave() {
      return !this.validData;
    },
  },
  created() {
    this.getCircuitBreakerData();
    this.updateHeaderTitle(this.$t('asset-information.asset-info.circuit-breaker.general-data'));
  },
  methods: {
    getCircuitBreakerData() {
      const { assetId } = this.$route.params;
      this.startLoading();
      GeneralDataService.getGeneralCircuitBreakerData(assetId)
        .then((res) => {
          this.circuitBreakerInfo = res;
        })
        .finally(() => {
          this.endLoading();
        });
    },
    save({ newValue, accept, reject }) {
      const { assetId } = this.$route.params;
      GeneralDataService.updateGeneraCircuitBreakerData(newValue, assetId)
        .then(accept)
        .catch(reject);
    },
    onValidDataChange(validData) {
      this.validData = validData;
    },
  },
};
</script>

<style lang="sass" scoped>
.registration-data
  &__loader
    min-height: 500px
  &__fields label
    margin-bottom: 0
</style>
